/* eslint-disable no-unused-vars */

enum CategoryType {
  noCategory,
  second,
  first,
  highest,
  third = 6,
}

const CATEGORIES = {
  [CategoryType.noCategory]: ['Нет', 'Нет'],
  [CategoryType.first]: ['1', 'Первая'],
  [CategoryType.second]: ['2', 'Вторая'],
  [CategoryType.highest]: ['Высшая', 'Высшая'],
  [CategoryType.third]: ['3', 'Третья'],
}

export default function filterGetTextCategory(category: 0 | 1 | 2 | 3 | 6, isNumberFormat: boolean) {
  return CATEGORIES[category][isNumberFormat ? 0 : 1]
}
